import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall } from '../CommonComponents/CustomHooks';
import Loader from '../CommonComponents/Loader';
import { useDispatch } from 'react-redux';
import { setLoginStatus } from '../../Redux/Services/AuthSlice';

const InvalidPage = () => {
    const inputrefs = useRef([]);
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false)
    const [loginData, setLoginData] = useState({ 
        password: '',
    });

    const handleLogin = async () => {
        setIsLoading(true);
        try {
            let res = await ApiCall(`/api/Login/CheckPassword`, loginData);
            if (res.status === 'SUCCESS') {
              
                const redirectPath = 
                    '/admin'  
                     
                dispatch(setLoginStatus(true))
                setTimeout(() => {
                    setIsLoading(false);
                    navigate(location.state || redirectPath);
                    localStorage.setItem('ID', "1");
                }, 700);
            } else {
                setIsLoading(false);
                NotificationSound(res.status, res.message, res.focus, inputrefs);
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Login failed', error);
            NotificationSound('ERROR', 'An unexpected error occurred. Please try again later.');
        }
    };

   
    return (
        <div className="container-fluid bg-login vh-100 d-flex justify-content-center align-items-center" >
            <div className="row" data-aos="zoom-in" data-aos-duration="1000" >
                <div className="col-sm-3 px-4 py-4 main-login text-black rounded">
                    <div className="text-center">
                        <img src="./images/login_logo.png" className='img1' alt="..." />
                    </div>
                    <div className="">
                        <h5
                            className="fw-bolder text-center pt-3 pb-2">
                            Enter Password to access <span className="text-danger">Admin Panel</span>
                        </h5>
                        
                        <div className="form-outline mb-2">
                            <label className="form-label" htmlFor="password">
                                Password
                            </label>
                            <input
                                type="password"
                               
                                maxLength='50'
                                value={loginData.password}
                                onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                                id="txtPassword"
                               
                                className="form-control form-control fs-6"
                                placeholder="Password"
                            />
                        </div>
                        <div className="pt-3 mb-2">
                            <button
                                type="button"
                               
                                id="btnLogin"
                                className={'btn btn-warning w-100 fw-bold'}
                                onClick={handleLogin}
                            >
                                Login <i className="fa-solid fa-arrow-right-to-bracket ms-1" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <Loader />}
        </div>
    );
};
export default InvalidPage;